import React from 'react'
import {Button} from '@material-ui/core'
import AddIcon from '@material-ui/icons/AddToPhotos'

import ValueFormatter from '../components/value-formatter'

import Config from '../config'

const getGridConfig = (actionClickHandler) => {

  let userData = Config.getConfig('userData')

  return [
    {
      field: "car_make",
      headerName: "Make",
      menuTabs : [],
      sortable: true,
      filter: true,
      width : 200,
    },
    {
      field: "registration",
      headerName: "Registration",
      menuTabs : [],
      sortable: true,
      filter: true,
      width : 180,
    },
    {
      field: "owner",
      headerName: "Owner",
      menuTabs : [],
      sortable: true,
      filter: true,
      width : 200,
    },
    {
      field: "active",
      headerName: "Active",
      menuTabs : [],
      sortable: false,
      filter: false,
      valueFormatter : item => ValueFormatter.yesNo(item.value),
      width : 100,
    },
    {
      field: "car_id",
      headerName: "Action",
      cellRenderer: 'actionCellRenderer',
      headerComponent: () => {
        return userData.edit_right ?
          (<Button onClick={event => actionClickHandler('new')} color="primary" startIcon={<AddIcon />}>new car</Button>)
          :
          (
          <div class="ag-cell-label-container">
          <div class="ag-header-cell-label">
              <span class="ag-header-cell-text"> </span>
          </div>
        </div>)
      },
      cellRendererParams: item => {
        return {
          clicked: actionClickHandler,
          view : true,
        }
      },
      menuTabs : [],
      filter: false,
      width : 150,
    },
  ]
}

export default getGridConfig
